import { render, staticRenderFns } from "./VideoSearch.vue?vue&type=template&id=a1411870&scoped=true&"
import script from "./VideoSearch.vue?vue&type=script&lang=js&"
export * from "./VideoSearch.vue?vue&type=script&lang=js&"
import style0 from "./VideoSearch.vue?vue&type=style&index=0&id=a1411870&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1411870",
  null
  
)

export default component.exports